export interface IFinancialAssistanceProgram {
  programId: string
  name: string
  policyCode?: string
}

export function formatFinancialAssistanceProgramLabel(
  program: Pick<IFinancialAssistanceProgram, 'name' | 'policyCode'>
): string {
  return program.policyCode
    ? `${program.name} (${program.policyCode})`
    : program.name
}

export interface IProgramFinancialAssistancePrograms {
  financialAssistancePrograms: string[]
  updatedAt?: string
}
